import { ref } from 'vue'
import { defineStore } from 'pinia'

export enum LogQueryTypeParam {
    MANUAL = 'manual',
    AUTOCOMPLETE = 'autocomplete',
    URL = 'url'
}
export const useLogQueryTypeStore = defineStore('logQueryType', () => {
  const lastQueryType = ref<LogQueryTypeParam>(LogQueryTypeParam.URL)

  return {
    lastQueryType
  }
})
